import * as React from "react";
const WidgetIcon3 = (props) => (
  <svg
    width={58}
    height={58}
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.85449 28.4268C7.85449 17.0332 17.0537 7.85938 29.0226 7.85938C40.9969 7.85938 50.1462 17.0387 50.1462 28.4268C50.1462 39.3798 41.7433 46.9209 30.8128 47.6725V52.7802L28.8002 52.5566C22.8049 51.8905 17.5712 48.527 13.8626 44.0724C10.1591 39.624 7.85449 33.9444 7.85449 28.4268ZM19.3337 30.8151C20.3348 30.8151 21.1462 30.0036 21.1462 29.0026C21.1462 28.0016 20.3348 27.1901 19.3337 27.1901C18.3327 27.1901 17.5212 28.0016 17.5212 29.0026C17.5212 30.0036 18.3327 30.8151 19.3337 30.8151ZM30.813 29.0026C30.813 30.0036 30.0015 30.8151 29.0005 30.8151C27.9995 30.8151 27.188 30.0036 27.188 29.0026C27.188 28.0016 27.9995 27.1901 29.0005 27.1901C30.0015 27.1901 30.813 28.0016 30.813 29.0026ZM38.6672 30.8151C39.6682 30.8151 40.4797 30.0036 40.4797 29.0026C40.4797 28.0016 39.6682 27.1901 38.6672 27.1901C37.6661 27.1901 36.8547 28.0016 36.8547 29.0026C36.8547 30.0036 37.6661 30.8151 38.6672 30.8151Z"
      fill="#B1B1B1"
    />
  </svg>
);
export default WidgetIcon3;
